<template>
  <div class="recall-team-page">
    <div v-wechat-title="'最强蜗牛'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      :gameName="gameName"
      :game_id="39"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="autoOpenOS"
      v-on:loginSuccess="loginSuccess"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <!-- 头部 -->
    <Header v-if='true'
      :config='headerConfig'
      :isShowInfo='true'
      :isOnline='1'
      :downloadApp="downloadApp" />
    <!-- 内容 -->

    <div class="active-page">
      <div class="section-container">
        <div class="section section1">
          <div class="btn-box">
            <a class="btn taptap-btn" @click="goLink('https://l.taptap.cn/ovT12vw0?channel=rep-rep_uvbcbbs5do5')"></a>
            <a class="btn hykb-btn" @click="goLink('https://m.3839.com/a/117233.htm')"></a>
          </div>
          <div class="banner"></div>
          <div class="recall-box" id="recall-box">
            <div class="detail-btn" data-snail-report-name="老友召回-详情按钮" @click="showPopup('recallDetailShow')"></div>
            <div class="time">
              <img class="date_1" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recall_date.png" alt="">
            </div>
            <div class="recall-content">
              <h5>
                <img v-if="(activeInfo.invite && (activeInfo.invite.status === 1 || activeInfo.invite.status === 3))" class="title_1" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recall_title_1.png" alt="">
                <img v-else class="title_2" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recall_title_2.png" alt="">
              </h5>
              <p class="tips">
                <img v-if="(activeInfo.invite && (activeInfo.invite.status === 1 || activeInfo.invite.status === 3))" class="tips_1"
                  src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recall_player_tips_1.png" alt="">
                <img v-else class="tips_2" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recall_player_tips_2.png" alt="">
              </p>
              <div v-if="(activeInfo.invite && activeInfo.invite.status === 3) ||(userInfo.game_id === 26)" class="seal-box">
                <div class="seal-img"></div>
                <div class="seal-title"></div>
              </div>
              <div class="player-box">
                <div class="player-item player-1"  @click="openLoginByPlayer()">
                  <div v-if="activeInfo.invite">
                    <img class="avatar" :src="activeInfo.invite.pic" alt="">
                    <div :class="'medal medal-' + activeInfo.invite.status"></div>
                    <div class="name">我</div>
                  </div>
                </div>
                <div class="player-item player-2">
                  <div v-if="invitePartnerInfo.id">
                    <img class="avatar" :src="invitePartnerInfo.pic" alt="">
                    <div :class="'medal medal-' + invitePartnerInfo.status"></div>
                    <div class="name">{{ invitePartnerInfo.nick_name }}</div>
                  </div>
                  <div v-else>
                    <div class="recall-invite-btn" data-snail-report-name="老友召回-立即邀请" @click="onRecallShare()">
                      <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/plus.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="welfare-box">
                <div class="reward-img">
                  <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/welfare_reward.png" alt="">
                </div>
                <div class="poster-1">
                  <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/welfare_img_1.png" alt="">
                </div>
                <div class="poster-2">
                  <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/welfare_img_2.png" alt="">
                </div>
              </div>
              <div class="download-btn" data-snail-report-name="老友召回-下载游戏" @click="toDownload()"></div>
            </div>
          </div>

          <div class="team-consumption-box" id="team-consumption-box">
            <div class="detail-btn" data-snail-report-name="组队消费-详情按钮" @click="showPopup('teamDetailShow')"></div>
            <div class="date">
              <img class="date_1" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/team_time_tips.png" alt="">
            </div>
            <div class="time" v-if="isActiveAppointment">
              <img class="time_1" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/pre-team_formation_tips.png" alt="">
            </div>
            <div class="team-consumption-content">
              <div class="member-num">
                队伍人数:【{{ memberNum }}/6】
                <div v-if="isActiveAppointment && userInfo.user_id && memberNum" class="exit-btn" @click="showPopup('teamExitShow')"></div>
              </div>
              <div class="member-list">
                <ul>
                  <li v-for="(item, idx) in teamList" :key="idx">
                    <div v-if="item.id" class="player-info" @click="readPlayerInfo(item.id)">
                      <img class="avatar" :src="item.pic" alt="">
                      <div :class="'medal medal-' + item.status"></div>
                      <div class="name">{{ item.is_myself ? '我' : item.nick_name }}</div>
                      <div v-if="item.is_first" class="captain"></div>
                    </div>
                    <div v-else>
                      <div class="player-info empty-seat" data-snail-report-name="组队付费-邀请好友" @click="onTeamShare()"></div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="tips">
                <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recharge_date_tips.png" alt="">
              </div>
              <div v-if="memberNum === 6" class="full-capacity-btn"></div>
              <div v-else class="invitation-btn" data-snail-report-name="组队付费-邀请好友" @click="onTeamShare()"></div>
            </div>

            <div class="consumption-points-box">
              <div class="operation-box">
                <div class="role-info" v-if="!userInfo.user_id">
                  <p>尚未登录</p>
                </div>
                <div v-else-if="userInfo.rid" class="role-info">
                  <p class="server_name">[{{ userInfo.server_name }}]</p>
                  <p class="name">{{ userInfo.role_name }}</p>
                </div>
                <div v-else class="bind-role-btn" data-snail-report-name="点击绑定领奖角色按钮" @click="onBindRolePopup()"></div>
                <div class="team-points">
                  团队累计积分:<span>{{ teamScore || 0 }}</span> <b data-snail-report-name="查看积分列表" @click="onMorePoints()"></b>
                </div>
                <div class="login-mask" v-if="!userInfo.user_id" data-snail-report-name="积分领取登录" @click="openLoginByScore()"></div>
              </div>

              <div class="welfare-list">
                <div class="reward-box" v-for="(item, idx) in packageList" :key="idx">
                  <div v-if="idx === 9" class="reward-item reward-item-10">
                    <div class="title title-10"></div>
                    <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/team_reward/final_reward_item_bg.png" alt="">
                    <div class="content">
                      <div class="reward-num"><b class="text_1"></b><span>{{ item.has_get_time }}</span><b class="text_2"></b></div>
                      <div class="progress-box">
                        <div class="progress-bg">
                          <div class="progress-val" :style="'width: ' + finallyProcess + '%'"></div>
                          <div class="num">{{ finallyScore }}/10000</div>
                        </div>
                        <div class="gold_medal"></div>
                        <div class="final-pop" data-snail-report-name="查看奖励礼包10" @click="clickReward(9)">
                          <span>{{ item.has_get_time }}</span>
                        </div>
                      </div>
                      <div class="reward-tips">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/team_reward/final_reward_tips.png" alt="">
                      </div>
                    </div>
                    <div v-if="item._get">
                      <div v-if="item.has_get_time === 20" class="obtained">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/obtained_icon.png" alt="">
                      </div>
                      <div v-if="item.can_get_time" class="not_obtained">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/to_be_obtained_icon.png" alt="">
                      </div>
                    </div>
                    <div v-else class="lock-box">
                      <div class="lock lock-10" data-snail-report-name="查看锁定奖励礼包10" @click="clickReward(9)"></div>
                      <div class="text">
                        <p style="display: flex;justify-content: center;align-items: center;">
                          <span class="stay_lock"></span>
                        </p>
                        <p class="lock_criterion">
                          <b class="score_text_prefix"></b>
                          <span>{{ teamScore || 0 }}</span>
                          <b class="score_text_suffix_10"></b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else :class="'reward-item reward-item-' + (idx + 1)">
                    <div :class="'title title-' + (idx + 1)"></div>
                    <img v-if="[1,3,6,8].includes(idx)" src="https://download4.qcplay.com/h5-images/active/snail/recall/2/team_reward/reward_item_bg_2.png" alt="">
                    <img v-else src="https://download4.qcplay.com/h5-images/active/snail/recall/2/team_reward/reward_item_bg.png" alt="">
                    <div class="reward-pop-box">
                      <div v-if="item._get" :class="'pop pop-' + (idx + 1)" :data-snail-report-name="'查看奖励礼包' + (idx + 1)" @click="clickReward(idx)"></div>
                    </div>
                    <div v-if="item._get">
                      <div v-if="item.is_get" class="obtained">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/obtained_icon.png" alt="">
                      </div>
                      <div v-else class="not_obtained">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/to_be_obtained_icon.png" alt="">
                      </div>
                    </div>
                    <div v-else class="lock-box">
                      <div :class="'lock lock-' + (idx + 1)" :data-snail-report-name="'查看锁定奖励礼包' + (idx + 1)" @click="clickReward(idx)"></div>
                      <div class="text">
                        <p style="display: flex;justify-content: center;align-items: center;">
                          <span class="stay_lock"></span>
                        </p>
                        <p class="lock_criterion">
                          <b class="score_text_prefix"></b>
                          <span>{{ teamScore || 0 }}</span>
                          <b :class="'score_text_suffix_' + (idx + 1)"></b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isActiveAppointment" class="not-enabled-tips">
                <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/not-enabled-tips.png" alt="">
              </div>
              <div v-else class="reward-btn" @click="onReward()"></div>

              <div class="tips">
                <!-- 修改 -->
                <div v-if="isActiveAppointment" class="pre-tip">
                  <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/pre-team-tips.png" alt="">
                </div>
                <div v-else>
                  <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/recharge_tips.png" alt="">
                  <div class="go_immediately_btn" data-snail-report-name="组队付费-前往官充" @click="toRecharge()"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="find_team_btn" @click="openFindTeamShow()">
            <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/find_team_icon.png"/>
          </div>

          <!-- 召回分享 -->
          <div class="recall-share-box" ref="recallImageDom">
            <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-share-popup.png"/>
            <div class="share-img">
              <div class="qrcode-box">
                <div id="recall-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
          <!-- 组队消费分享 -->
          <div class="team-share-box" ref="teamImageDom">
            <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/team-share-popup.png"/>
            <div class="team-info">
              <p>当前小队人数：<span>{{ memberNum === 0 ? 1 : memberNum }}</span>人</p>
              <p>剩余<span>{{ memberNum === 0 ? 5 : Math.max(6 - memberNum, 0) }}</span>空位</p>
            </div>
            <div class="share-img">
              <div class="qrcode-box">
                <div id="team-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 召回绑定弹窗组 -->
    <div>
      <!-- 召回绑定——详情弹窗 -->
      <div class="recall-detail-wrap popup_wrap" v-show="recallDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-detail-box popup_wrap-box" v-show="recallDetailShow">
            <div class="detail-content" v-if="recallDetailShow">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-rule.png" alt="">
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallDetailShow" @click="closePopup('recallDetailShow')"></div>
      </div>

      <!-- 召回绑定——召回失败(不符合条件) -->
      <div class="recall-failed-mismatch-condition-wrap popup_wrap" v-show="recallFailedMismatchConditionShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-box popup_wrap-box" v-show="recallFailedMismatchConditionShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="召回失败-参加其他活动" @click="toIndex('recallFailedMismatchConditionShow')"></div>
              <div class="btn recall-btn" data-snail-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow" @click="closePopup('recallFailedMismatchConditionShow')"></div>
      </div>
      <!-- 召回绑定——召回失败(不符合条件2 都是回归玩家) -->
      <div class="recall-failed-mismatch-condition-2-wrap popup_wrap" v-show="recallFailedMismatchConditionShow2">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-2-box popup_wrap-box" v-show="recallFailedMismatchConditionShow2">
            <div class="btn-box">
              <div class="btn qq-btn" data-snail-report-name="召回失败-前往QQ群" @click="toGroupOfQQ()"></div>
              <div class="btn wechat-btn" data-snail-report-name="召回失败-前往微信群" @click="toGroupOfWechat()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow2" @click="closePopup('recallFailedMismatchConditionShow2')"></div>
      </div>

      <!-- 召回绑定——召回失败(自己召回自己弹窗) -->
      <div class="recall-failed-myself-wrap recall-failed-wrap popup_wrap" v-show="recallFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-failed-myself-box popup_wrap-box" v-show="recallFailedMyselfShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-1.png" alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="召回失败-参加其他活动" @click="toIndex('recallFailedMyselfShow')"></div>
              <div class="btn recall-btn" data-snail-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
      </div>
      
      <!-- 召回绑定——召回失败(已经满员弹窗) -->
      <div class="recall-failed-full-strength-wrap recall-failed-wrap popup_wrap" v-show="recallFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-failed-full-strength-box popup_wrap-box" v-show="recallFailedFullStrengthShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-2.png" alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="召回失败-参加其他活动" @click="toIndex('recallFailedFullStrengthShow')"></div>
              <div class="btn recall-btn" data-snail-report-name="老友活动-召回其他人" @click="onRecallOther()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回失败(已有队伍弹窗) -->
      <div class="recall-failed-has-team-wrap recall-failed-wrap popup_wrap" v-show="recallFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-failed-has-team-box popup_wrap-box" v-show="recallFailedHasTeamShow">
            <div class="fail-tips">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/recall-fail-text-3.png" alt="">
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="召回失败-参加其他活动" @click="toIndex('recallFailedHasTeamShow')"></div>
              <div class="btn my-team-btn" data-snail-report-name="老友活动-查看我的组队" @click="toMyTeamByRecall()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回邀请 -->
      <div class="recall-invitation-wrap popup_wrap" v-show="recallInvitationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="recall-invitation-box popup_wrap-box" v-show="recallInvitationShow"> 
            <div class="player-box">
              <div class="player-item player-1">
                <img v-if="activeInfo.invite" class="avatar" :src="activeInfo.invite.pic" alt="">
                <div v-if="activeInfo.invite" :class="'medal medal-' + activeInfo.invite.status"></div>
                <div class="name">我</div>
              </div>
              <div class="player-item player-2">
                <img class="avatar" :src="recallSharePlayerInfo.share_pic" alt="">
                <div :class="'medal medal-' + recallSharePlayerInfo.share_status"></div>
                <div class="name">{{ recallSharePlayerInfo.share_nick_name }}</div>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="老友活动-残忍拒绝" @click="toIndex('recallInvitationShow')"></div>
              <div class="btn my-team-btn" data-snail-report-name="老友活动-接受邀请" @click="acceptInvitation()"></div>
            </div>
          </div>  
        </transition>
      </div>
    </div>

    <!-- 组队消费弹窗组 -->
    <div>
      <!-- 组队消费——详情弹窗 -->
      <div class="team-detail-wrap popup_wrap" v-show="teamDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-detail-box popup_wrap-box" v-show="teamDetailShow">
            <div class="detail-content" v-if="teamDetailShow">
              <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/popup/team-rule.png" alt="">
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamDetailShow" @click="closePopup('teamDetailShow')"></div>
      </div>

      <!-- 组队消费——玩家信息 -->
      <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow">
            <div class="player-info">
              <div class="top">
                <div class="avatar-box">
                  <img class="avatar" :src="curPlayerInfo.pic" alt="">
                </div>
                <div class="name">{{ curPlayerInfo.nick_name || '' }}</div>
              </div>

              <div class="info">
                <div class="row">
                  <div class="label">账号状态：</div>
                  <div class="value">{{ curPlayerInfo.type_desc || '' }}</div>
                </div>
                <div class="row">
                  <div class="label">上次登录时间：</div>
                  <div class="value">{{ `${curPlayerInfo.lastTime || ''}` }}</div>
                </div>
                <div class="row">
                  <div class="label">贡献积分：</div>
                  <div class="value">{{ isActiveAppointment ? 0 : (Number(curPlayerInfo.score) + 20) }}</div>
                </div>
              </div>
            </div>

            <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
              <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow')"></div>
              <div class="btn" v-if="curPlayerInfo.is_kick_out">
                <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                  <span>倒计时:{{ kickOutSeconds }}秒</span>
                </div>
                <div v-else class="kick-out-btn" @click="onKickOut()"></div>
              </div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamPlayerInfoShow" @click="closePopup('teamPlayerInfoShow')"></div>
      </div>

      <!-- 组队消费——玩家退出队伍弹窗 -->
      <div class="team-exit-wrap popup_wrap" v-show="teamExitShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-exit-box popup_wrap-box" v-show="teamExitShow">
            <div class="tips">
              当前队伍人数：{{ memberNum }}人
            </div>
            <div class="btn-box">
              <div class="btn confirm-btn" data-snail-report-name="退出队伍弹窗-确认退出" @click="onExitTeam()"></div>
              <div class="btn cancel-btn" @click="closePopup('teamExitShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamExitShow" @click="closePopup('teamExitShow')"></div>
      </div>

      <!-- 组队消费——玩家被踢出队伍提示弹窗 -->
      <div class="team-player-kick-out-tip-wrap popup_wrap" v-show="teamKickOutTipShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-player-kick-out-tip-box popup_wrap-box" v-show="teamKickOutTipShow">
            <div class="text">您已被踢出队伍</div>
            <div class="btn-box">
              <div class="btn confirm-btn" @click="closePopup('teamKickOutTipShow')"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 组队消费——积分记录弹窗 -->
      <div class="team-points-record-wrap popup_wrap" v-show="teamPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-points-record-box popup_wrap-box" v-show="teamPointsRecordShow">
            <div class="record-box">
              <ul>
                <li v-for="(item, idx) of scoreList" :key="idx">
                  <div class="left">
                    <div class="name">{{ item.remark }}</div>
                    <div class="date">{{ item.created_at && formatDate(item.created_at) }}</div>
                  </div>
                  <div class="right">积分:<span>{{ item.score }}</span></div>
                </li>
              </ul>
            </div>
            
            <div class="tips">
              <p>当前累计积分为：<span>{{ teamScore || 0 }}</span></p>
            </div>

          </div>
        </transition>
        <div class="close-bg" v-show="teamPointsRecordShow" @click="closePopup('teamPointsRecordShow')"></div>
      </div>
      <!-- 组队消费——积分记录弹窗 无积分 -->
      <div class="team-not-points-record-wrap popup_wrap" v-show="teamNotPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-not-points-record-box popup_wrap-box" v-show="teamNotPointsRecordShow">
            <div class="btn-box">
              <div class="btn confirm-btn" data-snail-report-name="组队付费-获取积分" @click="toRecharge()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamNotPointsRecordShow" @click="closePopup('teamNotPointsRecordShow')"></div>
      </div>

      <!-- 组队消费——入队失败(满员) -->
      <div class="team-join-failed-full-strength-wrap popup_wrap" v-show="teamJoinFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-join-failed-full-strength-box popup_wrap-box" v-show="teamJoinFailedFullStrengthShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="toIndex('teamJoinFailedFullStrengthShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedFullStrengthShow" @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
      </div>
      <!-- 组队消费——入队失败(已有队伍) -->
      <div class="team-join-failed-has-team-wrap popup_wrap" v-show="teamJoinFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-join-failed-has-team-box popup_wrap-box" v-show="teamJoinFailedHasTeamShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="toIndex('teamJoinFailedHasTeamShow')"></div>
              <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedHasTeamShow" @click="closePopup('teamJoinFailedHasTeamShow')"></div>
      </div>
      <!-- 组队消费——入队失败(自己邀请自己) -->
      <div class="team-join-failed-myself-wrap popup_wrap" v-show="teamJoinFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-join-failed-myself-box popup_wrap-box" v-show="teamJoinFailedMyselfShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="toIndex('teamJoinFailedMyselfShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedMyselfShow" @click="closePopup('teamJoinFailedMyselfShow')"></div>
      </div>
      <!-- 组队消费——邀请入队弹窗 -->
      <div class="team-invitation-join-wrap popup_wrap" v-show="teamInvitationJoinShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-invitation-join-box popup_wrap-box" v-show="teamInvitationJoinShow">
            <div class="team-info">
              <p>当前小队人数:<span>{{ teamInvitationNum === 0 ? 1 : teamInvitationNum }}</span>人</p>
              <p>剩余<span>{{ teamInvitationNum === 0 ? 5 : Math.max(6 - teamInvitationNum, 0) }}</span>个空位</p>
            </div>
            <div class="btn-box">
              <div class="btn reject-btn" data-snail-report-name="组队消费-拒绝入队" @click="rejectJoinTeam()"></div>
              <div class="btn agree-btn" data-snail-report-name="组队消费-立即入队" @click="agreeJoinTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationJoinShow" @click="closePopup('teamInvitationJoinShow')"></div>
      </div>
      <!-- 组队消费——邀请入队确认弹窗 -->
      <div class="team-invitation-confirm-wrap popup_wrap" v-show="teamInvitationConfirmShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="team-invitation-confirm-box popup_wrap-box" v-show="teamInvitationConfirmShow">
            <div class="team-info">
              <p>当前小队人数：{{ teamInvitationNum === 0 ? 1 : teamInvitationNum }}</p>
              <p>剩余空位：{{ teamInvitationNum === 0 ? 5 : Math.max(6 - teamInvitationNum, 0) }}</p>
              <p>奖励解锁等级：{{ Math.min(teamLevel, 10) }}(共10级)</p>
            </div>
            <div class="btn-box">
              <div class="btn confirm-btn" data-snail-report-name="组队消费-二次确认确定入队" @click="agreeJoinTeam()"></div>
              <div class="btn cancel-btn" data-snail-report-name="组队消费-二次确认拒绝入队" @click="rejectJoinTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationConfirmShow" @click="closePopup('teamInvitationConfirmShow')"></div>
      </div>
    </div>

    <!-- 召回绑定——微信分享 -->
    <div class="recall-wechat-share-wrap popup_wrap" v-show="recallWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class="'recall-wechat-share-box popup_wrap-box ' + ((activeInfo.invite && ([1,3].includes(activeInfo.invite.status))) ? 'new_player' : '')" v-show="recallWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="recallWechatShareShow" @click="closeWechatShare('recallWechatShareShow')"></div>
    </div>
    <!-- 召回绑定——分享弹窗 -->
    <div class="recall-share-wrap popup_wrap" v-show="recallNotWechatShareShow" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="recall-share-box popup_wrap-box" v-show="recallNotWechatShareShow">
          <img :src="recallShareImg" alt="分享图片" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('recall-clipboard-btn')" id="recall-clipboard-btn" data-snail-report-name="老友活动弹窗-复制链接"
            data-event="复制邀请链接" :data-clipboard-text="recallShareCopy.linkText + recallShareLink"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="recallNotWechatShareShow" @click="closePopup('recallNotWechatShareShow')"></div>
    </div>
    <!-- 组队消费——微信分享 -->
    <div class="team-wechat-share-wrap popup_wrap" v-show="teamWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="team-wechat-share-box popup_wrap-box" v-show="teamWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="teamWechatShareShow" @click="closeWechatShare('teamWechatShareShow')"></div>
    </div>
    <!-- 组队消费——分享弹窗 -->
    <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="team-share-box popup_wrap-box" v-show="teamNotWechatShareShow">
          <img :src="teamShareImg" alt="分享图片" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('team-clipboard-btn')" id="team-clipboard-btn" data-snail-report-name="付费活动弹窗-复制链接"
            data-event="复制邀请链接" :data-clipboard-text="teamShareCopy.linkText + teamShareLink"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="teamNotWechatShareShow" @click="closePopup('teamNotWechatShareShow')"></div>
    </div>
    
    <!-- 角色选择 -->
    <div class="snail-role-select-wrap popup_wrap"  v-show="snailRoleSelect">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="snail-role-select-box popup_wrap-box" v-show="snailRoleSelect">

          <div class="option-box">
            <div class="input">
              <select
                v-model="selectedRoleID"
                @focus="inputFocus()"
                @focusout="inputFocusOut()">
                <option value="">请选择区组</option>
                <option v-for="(item, index) in roleList" :key="index" :value="item.role_id">
                  <span>{{ "区服:" + item.server_name + " 综合实力:" + (item.extra && item.extra.score) }}</span>
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input
                type="text"
                name=""
                readonly
                v-model="roleName"
                placeholder="请选择角色"
                @focus="inputFocus()"
                @focusout="inputFocusOut()"
              />
            </div>
          </div>
          <div class="btn-box">
            <div class="cancel-btn" data-snail-report-name="组队消费-取消绑定角色" @click="closePopup('snailRoleSelect')"></div>
            <div class="confirm-btn" data-snail-report-name="组队消费-确认绑定角色" @click="reConfirmBindRolePopup()"></div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 组队消费——角色二次确认弹窗 -->
    <div class="team-bind-role-confirm-wrap popup_wrap" v-show="teamBindRoleConfirmShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="team-bind-role-confirm-box popup_wrap-box" v-show="teamBindRoleConfirmShow">
          <div class="tips">
            <p>[{{ selectedRoleInfo.server_name }}]</p>
            <p class="name">{{ selectedRoleInfo.role_name }}</p>
          </div>
          <div class="btn-box">
            <div class="btn confirm-btn" data-snail-report-name="组队消费-二次确认绑定角色" @click="confirmBindRole()"></div>
            <div class="btn cancel-btn" data-snail-report-name="组队消费-二次取消绑定角色" @click="closeReConfirmBindRole()"></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div class="btn qq-btn" data-snail-report-name="寻找搭子弹窗-去QQ" @click="toGroupOfQQ()"></div>
            <div class="btn wechat-btn" data-snail-report-name="寻找搭子弹窗-去微信" @click="toGroupOfWechat()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button class="monitor-btn" @click="onCopy('qq-clipboard-btn')" id="qq-clipboard-btn" data-snail-report-name="复制QQ群号"
            data-event="复制QQ群号" :data-clipboard-text="qqNumber"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="qqGroupShow" @click="closePopup('qqGroupShow')"></div>
    </div>

    <!-- 奖励弹窗组 -->
    <div>
      <!-- 奖励弹窗——卡片形象详情 -->
      <div class="character-wrap popup_wrap" v-show="characterShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="character-box popup_wrap-box" v-show="characterShow">
            <div class="btn close-btn" @click="closePopup('characterShow')"></div>
          </div>
        </transition>
        <div class="close-bg" v-show="characterShow" @click="closePopup('characterShow')"></div>
      </div>

      <!-- 奖励弹窗——启航携手礼包 -->
      <div class="cooperation-wrap popup_wrap" v-show="cooperationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="cooperation-box popup_wrap-box" v-show="cooperationShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('cooperationShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="cooperationShow" @click="closePopup('cooperationShow')"></div>
      </div>

      <!-- 奖励弹窗——奇点水晶礼包 -->
      <div class="crystal-wrap popup_wrap" v-show="crystalShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="crystal-box popup_wrap-box" v-show="crystalShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('crystalShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="crystalShow" @click="closePopup('crystalShow')"></div>
      </div>

      <!-- 奖励弹窗——组队幸运礼包 -->
      <div class="lucky-wrap popup_wrap" v-show="luckyShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="lucky-box popup_wrap-box" v-show="luckyShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('luckyShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="luckyShow" @click="closePopup('luckyShow')"></div>
      </div>

      <!-- 奖励弹窗——贵重物品详情 -->
      <div class="valuables-wrap popup_wrap" v-show="valuablesShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="valuables-box popup_wrap-box" v-show="valuablesShow">
          </div>
        </transition>
        <div class="close-bg" v-show="valuablesShow" @click="closePopup('valuablesShow')"></div>
      </div>
      <!-- 奖励弹窗——贵重物品详情 -->
      <div class="activity-benefits-wrap popup_wrap" v-show="activityBenefitsShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="activity-benefits-box popup_wrap-box" v-show="activityBenefitsShow">
            <div class="btn-box">
              <div class="btn close-btn" @click="closePopup('activityBenefitsShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="activityBenefitsShow" @click="closePopup('activityBenefitsShow')"></div>
      </div>
    </div>
    

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast , Indicator} from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList } from "@/api/os";
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, recallInitAPI, teamInitAPI, recallBindPlayerAPI,
  teamKickAPI, teamExitAPI, teamRewardAPI, teamJoinAPI } from '../api';
import { getRandomString, buriedLogger , wechatBrowser } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

// import eruda from 'eruda';

const PLAYER_TYPE = {
  1: '活跃玩家',
  2: '回归玩家',
  3: '新玩家',
};
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: 'RecallTeamActive',
  components: {
    Header,
    Footer,
    Login,
  },
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      loginTypes: ["sms", "password"],
      autoOpenOS: false,
      preloadingShow: true,
      logger: null,
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      consumptionLevel: [50,100,150,200,400,800,1500,3000,5000,10000],
      recallShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },
      teamShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },

      code: '',
      auth_code: '',
      friend_id: '',
      recallShareLink: '',
      teamShareLink: '',
      recallShareImg: '',
      teamShareImg: '',

      // 弹窗
      preventShow: false, // 全局遮罩
      snailRoleSelect: false, // 角色选择
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      recallDetailShow: false, // 召回绑定——详情弹窗
      recallWechatShareShow: false, // 召回绑定——微信分享弹窗
      recallNotWechatShareShow: false, // 召回绑定——非微信分享弹窗
      recallFailedMismatchConditionShow: false, // 召回绑定——不满足条件弹窗
      recallFailedMyselfShow: false, // 召回绑定——自己召回自己弹窗
      recallFailedFullStrengthShow: false, // 召回绑定——已有好友弹窗
      recallFailedHasTeamShow: false, // 召回绑定——已有队伍弹窗
      recallFailedMismatchConditionShow2: false, // 召回绑定——都是回归玩家
      recallInvitationShow: false, // 召回绑定——邀请弹窗

      teamDetailShow: false, // 组队消费——详情弹窗
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamKickOutTipShow: false, // 组队消费——玩家被踢出队伍弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamBindRoleConfirmShow: false, // 组队消费——绑定角色确认弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗

      characterShow: false, // 奖励弹窗——卡片形象详情
      cooperationShow: false, // 奖励弹窗——启航携手礼包
      crystalShow: false, // 奖励弹窗——奇点水晶礼包
      luckyShow: false, // 奖励弹窗——组队幸运礼包
      valuablesShow: false, // 奖励弹窗——贵重物品详情
      activityBenefitsShow: false, // 奖励弹窗——运营活动福利礼包

      recallActiveInfo: {},
      teamActiveInfo: {},
      teamList: Array.from({length: 6}, () => ({})),
      packageList: Array.from({length: 10}, () => ({})),
      memberNum: 0,
      curPlayerInfo: {},
      invitePartnerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: false,

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期

      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      qqNumber: '',
      qqLink: '',
      wechatLink: '',
      pageLink: '',
    }
  },
  created () {
    const targetDate = new Date('2025/06/20 4:59:59');
    // 获取当前时间
    const currentDate = new Date();
    // 计算时间差
    const timeDifference = targetDate - currentDate;
    // 如果时间差大于0，说明在预约期，否则不在预约期
    this.isActiveAppointment = timeDifference ? true : false;
    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA =  urlParams.get('ua');
    const module = urlParams.get('module');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('module');
    urlParams.delete('ua');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({length: 6}, () => ({}));

    // 初始化
    this.onInitDate(true);

    // 埋点
    const bl = buriedLogger('snail', '五周年庆_召回绑定与组队消费');
    this.logger = bl;
    if (module === 'recall') {
      this.$nextTick(() => {
        this.scrollIntoRecallBox();
      });
    } else if (module === 'team') {
      this.$nextTick(() => {
        this.scrollIntoTeamBox();
      });
    }
    if (queryUA === 'snail') {
      this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=39&ua=snail';
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: "《最强蜗牛》五周年版本上线",
      imgUrl: "https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png",
      desc: "什么！百抽都成基础福利了？",
    });

  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => { }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick, true);
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });
  },
  computed: {
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID).role_name
        : "";
      return roleName;
    },
    finallyScore() {
      if (!this.activeInfo.team) {
        return 0;
      }
      const num = this.packageList[9].has_get_time;
      if (num === 20) {
        return 10000;
      }
      return this.teamScore - num * 10000;
    },
    finallyProcess() {
      if (!this.finallyScore) {
        return 0;
      }
      return Math.min((this.finallyScore / 10000) * 100, 100);
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          console.log('初始登陆/切换角色')
          this.getRecallInit();
          this.getTeamInit();
          const { protocol, host } = window.location;
          this.recallShareLink = `${protocol}//${host}/snail/recall/enter${getRandomString()}?code=${this.activeInfo.invite.code}`;
          this.teamShareLink = `${protocol}//${host}/snail/recall/enter${getRandomString()}?friend_id=${this.activeInfo.team.team_code}`;
          this.initRecallShareData();
          this.initTeamShareData();

          this.isActiveAppointment = this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS;
        }
      }
    }
  },
  methods: {
    // 事件委托
    handleGlobalClick(e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`五周年庆_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 初始化
    onInitDate(isFirst = false) {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code !== 200) {
          !isFirst && this.onToast(response.message);
          return;
        }
        this.getTeamListData();
        this.invitePartnerInfo = this.activeInfo.invite.invite_list[0] || {};
        this.teamScore = Number(this.activeInfo.team.team_score) || 0;
        this.scoreList = this.activeInfo.team.score_list || [];
        this.rewardLevel = Number(this.activeInfo.team.level) || 0;
        this.rewardList = this.activeInfo.team.reward_list || [];
        this.packageList = this.activeInfo.team.package_list || [];

        this.qqNumber = this.activeInfo.qq;
        this.qqLink = this.activeInfo.qq_link;
        this.wechatLink = this.activeInfo.invite.url_scheme;
        if (this.activeInfo.team.is_has_out_news) {
          this.showPopup('teamKickOutTipShow');
        }
        // 设置welfare-list的滚动位置
        const targetElement = document.getElementsByClassName('welfare-list');
        const idx = this.packageList.findIndex(item => item._get && !item.is_get);
        if (targetElement[0] && idx !== -1) {
          targetElement[0].scrollTop = document.getElementsByClassName(`reward-item-${idx+1}`)[0].offsetTop - 10;
        }
      });
    },
    clearDate() {
      this.teamActiveInfo = {};
      this.recallActiveInfo = {};
      this.teamList = Array.from({length: 6}, () => ({}));
      this.packageList = Array.from({length: 10}, () => ({}));
      this.memberNum = 0;
      this.roleList = [];
      this.invitePartnerInfo = {};
      this.recallSharePlayerInfo = {};
      this.teamScore = 0;
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.recallShareImg = '';
      this.teamShareImg = '';
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.recallShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };
      this.teamShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };
    },
    async getRecallInit () {
      if (!this.activeInfo.invite.is_start) {
        return;
      }
      // 请求头里面有带code或者auth_code的发起api请求
      if (this.code || this.auth_code) {
        if (this.code === this.activeInfo.invite.code) {
          this.showPopup('recallFailedMyselfShow');
          return false;
        }
        const response = await recallInitAPI({ code: this.code, auth_code: this.auth_code });
        if (response.code === 200) {
          const { is_start, is_my, share_nick_name, share_pic, share_status } = response.data.activity;
          if (!is_start) {
            this.onToast('活动将于6月20日5:00开启，敬请期待！');
          } else if (is_my) {
            // 自己召回自己
            this.showPopup('recallFailedMyselfShow');
          } else {
            this.recallSharePlayerInfo = { share_nick_name, share_pic, share_status };
            this.showPopup('recallInvitationShow');
          }
        } else if (response.code === 405) {
          this.showPopup('recallFailedFullStrengthShow');
        } else {
          this.onToast(response.message);
        }
      }
    },
    async getTeamInit () {
      if (this.friend_id) {
        const response = await teamInitAPI({ friend_id: this.friend_id });
        if (response.code === 200) {
          const { is_my, number, is_join, level } = response.data.activity;
          if (is_my) {
            this.showPopup('teamJoinFailedMyselfShow');
          } else if (is_join) {
            this.showPopup('teamJoinFailedHasTeamShow');
          } else if (number === 6) {
            this.showPopup('teamJoinFailedFullStrengthShow');
          } else {
            if (this.isActiveAppointment === false) {// 如果是非预组队期间
              this.needInvitationConfirm = true;
            }
            // this.teamInvitationNum = number === 0 ? 1 : number;
            this.teamInvitationNum = number;
            this.teamLevel = level;
            this.showPopup('teamInvitationJoinShow')
          }
        } else {
          this.onToast(response.message);
        }
      }
    },
    // 去下载
    toDownload() {
      this.downloadApp();
    },
    goLink(url) {
        if (url === '') return
        Indicator.open();
        setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    // 跳转到首页
    toIndex(popupName) {
      this.closePopup(popupName);
      this.recallSharePlayerInfo = {};
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/snail/recall/anniversary${getRandomString()}`;
    },
    openFindTeamShow() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum('五周年庆_寻找搭子按钮');
      this.showPopup('findTeamShow');
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.closePopup('recallFailedMismatchConditionShow2');
        this.closePopup('findTeamShow');

        this.showPopup('qqGroupShow');
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat() {
      window.location.href = this.wechatLink;
    },
    initRecallShareData() {
      if (!this.activeInfo.invite.is_start) {
        return;
      }
      try {
        // 设置分享文案
        const isReturnPlayer = this.activeInfo.invite.status === 2;
        this.recallShareCopy = {
          title: isReturnPlayer ? '邀请蜗的挚友，组队领取福利' : '回归最好时机，组队送福利',
          desc: isReturnPlayer ?
            '周年庆典强势来袭！参与召回活动，可消耗1白蝌蚪购买¥328礼包！快来和我组队吧' :
            '周年庆版本全面焕新！新主角、新养成、新地图强势来袭，更有组队福利等你来拿！戳我速速组队回归',
          linkText: isReturnPlayer ?
            '周年庆版本全面焕新！新主角、新养成、新地图强势来袭，更有组队福利等你来拿！快来和我组队吧！' :
            '《最强蜗牛》周年庆版本全面焕新！新主角、新养成、新地图强势来袭，更有回归福利等你来拿！戳我速速组队回归！',
        }
        this.qrcode('recall-qrcode', `${this.recallShareLink}`);
        this.$nextTick(() => {
          this.generateRecallShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log('召回分享初始化失败', err);
      }
    },
    initTeamShareData() {
      try {
        // 生成一个随机数，用于判断随机使用两种文案中的一种
        const randomNum = Math.random();
        if (randomNum > 0.5) {
          this.teamShareCopy = {
            title: '积分池组队领福利',
            desc: '听说了吗，《最强蜗牛》积分池组队活动，参与可获得限定肖像、限定绿贵、狗眼等珍贵奖励，就差你没来了！',
            linkText: '《最强蜗牛》积分组队活动，参与可获得限定肖像、限定绿贵、狗眼等珍贵奖励，就差你了！',
          };
        } else {
          this.teamShareCopy = {
            title: '积分组队邀请函',
            desc: '你好！我们正在为《最强蜗牛》积分活动组队，参与可获得限定肖像、限定绿贵、狗眼等珍贵奖励，你愿意加入我们吗？',
            linkText: '你好！我们正在参加《最强蜗牛》积分组队活动，参与可获得限定肖像、限定绿贵、狗眼等珍贵奖励，你愿意加入我们吗？',
          };
        }

        this.qrcode('team-qrcode', `${this.teamShareLink}`);
        this.$nextTick(() => {
          this.generateTeamShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('组队分享初始化失败', err);
      }
    },
    // 生成二维码
    qrcode (id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#eee4d4',
        colorLight: '#c5a790'
      });
    },
    onCopy (id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    // 分享图片设置
    generateRecallShareImage () {
      generateCanvasImage(this.$refs.recallImageDom)
        .then((canvas) => {
          this.recallShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('召回分享图生成成功');
        })
        .catch((err) => {
          console.log('召回分享图生成失败', err.message);
        });
    },
    generateTeamShareImage (successCallback, failedCallback) {
      generateCanvasImage(this.$refs.teamImageDom)
        .then((canvas) => {
          this.teamShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          successCallback && successCallback();
          console.log('组队分享图生成成功');
        })
        .catch((err) => {
          failedCallback && failedCallback();
          console.log('组队分享图生成失败', err.message);
        });
    },
    onRecallShare() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.activeInfo.invite.is_start) {
        this.onToast('活动将于6月20日5:00开启，敬请期待');
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?code=${this.activeInfo.invite.code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.recallShareLink,
          title: this.recallShareCopy.title,
          imgUrl: "https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png",
          desc: this.recallShareCopy.desc,
        });
        this.recallWechatShareShow = true;
        this.logger.sum('五周年庆_老友活动-引导遮罩')
      } else {
        this.recallNotWechatShareShow = true;
      }
    },
    onTeamShare() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?friend_id=${this.activeInfo.team.team_code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.teamShareLink,
          title: this.teamShareCopy.title,
          imgUrl: "https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png",
          desc: this.teamShareCopy.desc,
        });
        this.teamWechatShareShow = true;
        this.logger.sum('五周年庆_组队付费-引导遮罩')
      } else {
        this.onPreventShow();
        this.generateTeamShareImage(() => {
          this.onPreventClose();
          this.teamNotWechatShareShow = true;
        }, () => {
          this.onPreventClose();
        })
      }
    },
    closeWechatShare(popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    getTeamListData () {
      let teamList = this.activeInfo.team.team_list || [];
      teamList.forEach((item) => {
        const { y, m, d, h, status } = item;
        if (y) {
          item.lastTime = `${y}年前`; 
        } else if (m) {
          item.lastTime = `${m}月前`;
        } else if (d) {
          item.lastTime = `${d}天前`;
        } else {
          item.lastTime = '今天';
        }
        item.type_desc = PLAYER_TYPE[status];
        item.is_myself = this.userInfo.user_id === item.id;
        item.is_kick_out = this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS &&
          this.activeInfo.team.is_first && !item.is_myself;
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 6) {
        const fillCount = 6 - teamList.length;
        const fillArray = Array.from({length: fillCount}, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team.team_list.length;
    },
    // 接受邀请
    async acceptInvitation() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await recallBindPlayerAPI({ code: this.code });
      switch (response.code) {
        case 200:
          this.onToast('绑定成功');
          this.onInitDate();
          break;
        case 405:
          // 对方队伍已满员
          this.showPopup('recallFailedFullStrengthShow');
          break;
        case 406: // 不能自己绑定自己 
          this.showPopup('recallFailedMyselfShow');
          break;
        case 407: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 408: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 501:
          // 自己已经有队伍
          this.showPopup('recallFailedHasTeamShow');
          break;
        case 502:
          // 两个都是回归玩家
          this.showPopup('recallFailedMismatchConditionShow2');
          break;
        case 503: // 不符合条件 有一个人是新玩家的时候
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 504: // 不符合条件 两个活跃玩家
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        default:
          this.onToast(response.message);
      }
      
      this.onPreventClose();
      this.closePopup('recallInvitationShow');
      this.recallSharePlayerInfo = {};
    },
    toMyTeamByRecall () {
      this.closePopup('recallFailedHasTeamShow');
      this.scrollIntoRecallBox();
    },
    // 查看我的组队
    toMyTeamByTeam() {
      this.closePopup('teamJoinFailedHasTeamShow');
      // TODO: 锁定到页面召回板块
      this.scrollIntoTeamBox();
    },
    scrollIntoRecallBox () {
      const targetElement = document.getElementById('recall-box');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollIntoTeamBox () {
      const targetElement = document.getElementById('team-consumption-box');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onRecallOther() {
      if (this.userInfo.game_id === 26 || this.activeInfo.invite.status === 3) {
        this.onToast('召回失败！尚未满足触发条件！');
        return;
      }
      this.closePopup('recallFailedMismatchConditionShow');
      this.closePopup('recallFailedFullStrengthShow');
      this.closePopup('recallFailedMyselfShow');
      this.closePopup('recallFailedHasTeamShow');
      this.onRecallShare();
    },
    readPlayerInfo(id) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup('teamPlayerInfoShow');
    },
    // 踢出队伍
    async onKickOut() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamKickAPI({ id: this.curPlayerInfo.id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('已踢出队伍');
        this.closePopup('teamPlayerInfoShow');
        this.onInitDate();
        this.logger.sum('五周年庆_弹窗-踢出队伍');
      }
      this.onPreventClose();
    },
    // 查看更多积分
    onMorePoints() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.teamScore) {
        this.showPopup('teamPointsRecordShow');
      } else {
        this.showPopup('teamNotPointsRecordShow');
      }
    },
    // 跳转到充值网站
    toRecharge() {
      window.location.href = this.rechargeUrl;
    },
    async onExitTeam () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamExitAPI();
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.closePopup('teamExitShow');
        this.onInitDate();
      }
      this.onPreventClose();
    },
    async rejectJoinTeam() {
      this.toIndex('teamInvitationJoinShow');
    },
    async agreeJoinTeam() {
      if (this.needInvitationConfirm) {
        this.closePopup('teamInvitationJoinShow');
        this.showPopup('teamInvitationConfirmShow');
        this.needInvitationConfirm = false;
        return;
      }
      this.onPreventShow();
      const response = await teamJoinAPI({ friend_id: this.friend_id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('入队成功');
      }
      this.onPreventClose();
      this.closePopup('teamInvitationJoinShow');
      this.closePopup('teamInvitationConfirmShow');
      this.onInitDate();
    },
    // 领取奖励
    async onReward () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.userInfo.rid) {
        this.onBindRolePopup();
        return;
      }
      this.onPreventShow();
      const response = await teamRewardAPI();
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('领取成功');
        this.onInitDate();
      }
      this.onPreventClose();
    },
    // 角色选弹窗
    async onBindRolePopup () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      // 未加入队伍的
      if (this.activeInfo.team.team_list.length === 0) {
        this.onToast('很抱歉,你还没有加入队伍!');
        return;
      }

      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName]
      });

      if (Number(roleResponse.code) === 200) {
        // 正式服ID
        const serverIds = GAME_AREA[this.gameName][1].id;
        let data = roleResponse.data[serverIds] || [];
        this.roleList = data['android'];
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      }
    },
    // 角色信息二次确认弹窗
    reConfirmBindRolePopup() {
      if (this.selectedRoleID === "") {
        return this.onToast('请选择区组');
      }
      let selectInfo = this.roleList.find(
        item => item.role_id === this.selectedRoleID
      );
      selectInfo.type = "android";
      selectInfo.dist = APP_ID[this.gameName];
      selectInfo.extra = JSON.stringify(selectInfo.extra);
      this.selectedRoleInfo = selectInfo;
      this.closePopup("snailRoleSelect");
      this.showPopup('teamBindRoleConfirmShow');

    },
    closeReConfirmBindRole () {
      this.selectedRoleInfo = {};
      this.closePopup('teamBindRoleConfirmShow');
    },
    confirmBindRole() {
      this.onPreventShow();
      teamRewardAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.closePopup("teamBindRoleConfirmShow");
          this.onToast('绑定成功');
          this.onInitDate();
        } else {
          this.onToast(response.message);
        }
      }).finally(() => {
        this.onPreventClose();
      });
    },
    loginSuccess () {
      this.onInitDate();
    },
    clickReward(id) {
      const popupList = [
        'activityBenefitsShow', 'characterShow', 'activityBenefitsShow', 'valuablesShow', 'activityBenefitsShow',
        'activityBenefitsShow', 'crystalShow', 'activityBenefitsShow', 'cooperationShow', 'luckyShow'
      ];
      const popupName = popupList[id];
      if (popupName) {
        this.showPopup(popupName);
      }
    },
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : '0' + minutes}:${seconds >= 10 ? seconds : '0' + seconds}`;
    },
    openLoginByScore() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    openLoginByPlayer () {
      console.log(this.userInfo.user_id)
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    // TAG: 其他简易封装的方法
    onToast (config , duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow () {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose () {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>
<style lang="less" scoped>
@import url("./index.less");

</style>


// WEBPACK FOOTER //
// src/pages/snail/recall/index/index.vue